<script setup lang="ts">
interface ProgrammeTypeData {
  id: string
  title: string
  slug: string
  type: string
  content?: any[]
}

defineProps<{
  programmeType: ProgrammeTypeData
}>()
</script>

<template>
  <div>
    <pages-programme-type-blocks
      v-if="programmeType.content?.length"
      :blocks="programmeType.content"
      :type-slug="programmeType.slug"
      :type-id="programmeType.id"
    />
  </div>
</template>
